import { PrimaryButtonProps } from 'ia-react-core';
import React, { FC } from 'react';
import { StyledPrimaryButton } from './WelcomeBoxButton.styles';

export interface WelcomeBoxButtonProps extends Omit<PrimaryButtonProps, 'children'> {
  singular: string;
  plural: string;
  count: number;
}

const WelcomeBoxButton: FC<WelcomeBoxButtonProps> = ({ count, singular, plural, ...props }) => (
  <StyledPrimaryButton isLeftMostIcon reversed {...props}>
    {count > 99 ? '99+' : count} {count > 1 ? plural : singular}
  </StyledPrimaryButton>
);

WelcomeBoxButton.displayName = 'WelcomeBoxButton';

export default WelcomeBoxButton;
